import { TableCell, TableContainer } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, createGlobalStyle, css } from "styled-components";
import { OrderStatus } from "../../../../models/Order";


export const StyledSortableItem = styled.div<{isDragging: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e7eb; /* Tailwind's border color */
  padding: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
      cursor: pointer;
	  width:100%;
	  height: 100%;

  ${({ isDragging }) =>
    isDragging &&
    `
    opacity: 0.5;
    // transform: scale(1.05);
    background-color: #bfdbfe; /* Tailwind's bg-blue-100 */
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  `}

   touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
`;

export const StyledSortableItemButton = styled.button`
     cursor: pointer;
    border-radius: 8px;
    padding: 12px 16px;
    border: 1px solid rgb(229, 231, 235);
    height: 48px;
    color: rgb(255, 255, 255);
    display: flex
;
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(3, 93, 157);
`;

export const StyledSortableItemDivWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const StyledSortableItemWrap = styled.div`
    display: flex;
    justify-content: space-between;
	height: 48px;
    margin-bottom: 12px;

`;

export const StyledSortableItemButtonCheck = styled.button`
     cursor: pointer;
    border-radius: 8px;
    padding: 12px 16px;
    border: 1px solid rgb(229, 231, 235);
    height: 48px;
    color: rgb(255, 255, 255);
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(3, 93, 157);
	width: 60px;
    justify-content: center;
	    margin-left: 12px;
`;

export const StylePagePersonContentKey = styled.div<{
	xStylePageSet?: FlattenSimpleInterpolation;
}>`
	color: var(--text-color0);
	width: 150px;
	display: inline-block;

	@media screen and (max-width: 768px) {
		display: block;
		width: 100%;
		margin-bottom: 4px;
		&:last-child {
			margin-left: 0px;
		}
	}
	${(props) => (props.xStylePageSet ? props.xStylePageSet : "")}
`;
export const StylePersonalLabelBank = styled(StylePagePersonContentKey)`
	width: 100%;
	margin-bottom: 8px;
	color: var(--text-color2);
	font-family: SF-Pro-Display;
	@media screen and (max-width: 768px) {
		margin-bottom: 0px;
	}
`;